export default __webpack_public_path__ + "static/media/Cortico.41ba7aaf.jpg";